import type { Diagnostic } from './model';

/** Diagnostic texts. Kept inside the language package so modules get the same wording. */
const MESSAGES: Record<'ru' | 'en', Record<string, string>> = {
  ru: {
    missingHeader: 'Пустая диаграмма: начните с заголовка «схема» или «последовательность»',
    unknownHeader: 'Неизвестный вид диаграммы «{word}». Ожидается «схема» или «последовательность»',
    unknownDirection: 'Неизвестное направление «{word}» — используется «вниз»',
    unexpectedText: 'Лишний текст после заголовка: «{text}»',
    expectedBrace: 'Ожидается «{» в конце строки',
    unexpectedBrace: 'Лишняя «}» — нет открытого блока',
    unclosedBlock: 'Блок «{name}» не закрыт: добавьте «}»',
    unknownStatement: 'Непонятная строка: «{text}»',
    badId: 'Недопустимое имя «{id}»: буквы, цифры, «_», «-» или текст в кавычках',
    badColor: 'Цвет «{value}» не распознан — используйте #rrggbb',
    badNumber: 'Число «{value}» не распознано',
    unknownStyleKey: 'Неизвестное свойство стиля «{key}»',
    unknownClass: 'Класс «{name}» не объявлен',
    missingTarget: 'У связи нет начала или конца',
    badSection: '«{word}» допустимо только внутри «если» или «параллельно»',
    badNote: 'Заметка: «заметка над|слева от|справа от имя : текст»',
    duplicateNode: '«{id}» уже объявлен — значения объединены',
    similarNode: '«{id}» встречается один раз и похоже на «{other}» — опечатка?',
  },
  en: {
    missingHeader: 'Empty diagram: start with a “flow” or “sequence” header',
    unknownHeader: 'Unknown diagram kind “{word}”. Expected “flow” or “sequence”',
    unknownDirection: 'Unknown direction “{word}” — using “down”',
    unexpectedText: 'Unexpected text after the header: “{text}”',
    expectedBrace: 'Expected “{” at the end of the line',
    unexpectedBrace: 'Extra “}” — no open block',
    unclosedBlock: 'Block “{name}” is not closed: add “}”',
    unknownStatement: 'Cannot understand: “{text}”',
    badId: 'Invalid name “{id}”: letters, digits, “_”, “-” or quoted text',
    badColor: 'Color “{value}” not recognized — use #rrggbb',
    badNumber: 'Number “{value}” not recognized',
    unknownStyleKey: 'Unknown style property “{key}”',
    unknownClass: 'Class “{name}” is not declared',
    missingTarget: 'The link has no start or end',
    badSection: '“{word}” is only allowed inside “alt” or “par”',
    badNote: 'Note: “note over|left of|right of name : text”',
    duplicateNode: '“{id}” is already declared — values merged',
    similarNode: '“{id}” is used once and looks like “{other}” — a typo?',
  },
};

export function formatDiagnostic(d: Diagnostic, locale: string): string {
  const table = MESSAGES[locale === 'ru' ? 'ru' : 'en'];
  const text = table[d.code] ?? d.code;
  return text.replace(/\{(\w+)\}/g, (_, k: string) => d.params?.[k] ?? '');
}
